import { connect } from 'react-redux'
import { firebaseConnect, getVal } from 'react-redux-firebase'
import { inviteUsers } from '../../store/actions/share'
import {
  accessListSelector,
  getAccess
} from '../../store/selectors/accessSelectors'
import { compose } from 'redux'
import ReactGA from 'react-ga'
import {
  withHandlers,
  withProps,
  branch,
  renderComponent,
  mapProps
} from 'recompose'
import { EDITOR, VIEWER, COMMENTER } from '../../constants'
import { withTranslation } from 'react-i18next'
import pick from 'lodash/pick'
import { asModal } from 'common/Modal/Modal'
import Loader from '../common/Loader'
import { push } from 'react-router-redux'

const track = action => {
  ReactGA.event(
    {
      category: 'Share',
      action: `${action} Share Modal`
    },
    ['app']
  )
}

const ShareModalContainer = compose(
  connect(
    (state, { match }) => {
      const item = getVal(
        state.firebase,
        `data/${match.params.type}s/${match.params.id}`
      )
      return {
        shares: getVal(state.firebase, `data/shares/${match.params.id}`),
        item,
        access: item && getAccess(item.id, accessListSelector(state))
      }
    },
    (dispatch, { match }) => ({
      inviteUsers: (users, level) =>
        dispatch(
          inviteUsers(
            { id: match.params.id, type: match.params.type },
            users,
            level
          )
        ),
      close: () => dispatch(push('.', {}))
    })
  ),
  firebaseConnect(({ match, item, access }) => {
    const watchArray = [`/${match.params.type}s/${match.params.id}`]
    // editors can load the share list
    if (access >= EDITOR) watchArray.push(`/shares/${match.params.id}`)
    return watchArray
  }),
  withHandlers({
    close: ({ close }) => () => {
      close()
      track('Close')
    },
    onAfterOpen: () => () => track('Open')
  }),
  withProps(({ item, shares, access }) => {
    // Still loading
    if (!item) return {}

    const props = { users: [], invites: [], loaded: true }

    if (access >= EDITOR) {
      Object.values(shares || {}).forEach(share => {
        // don't show anonymous shares - added to allow non-users to view
        if (!share || share.anonymous) return

        // migrate
        if (!share.accessLevel) share.accessLevel = share.level

        // sort into:
        // shares (accepted),
        // invites (single-use, not accepted),
        // and multi-use links (the view and edit link)
        if (share.dateAccepted) {
          props.users.push(share)
        } else if (share.multiUse) {
          if (share.accessLevel === VIEWER) props.viewLink = share
          if (share.accessLevel === COMMENTER) props.discussLink = share
          if (share.accessLevel === EDITOR) props.editLink = share
        } else {
          props.invites.push(share)
        }
      })

      // default discuss link
      if (!props.discussLink) {
        props.discussLink = {
          item: pick(item, ['id', 'type', 'name']),
          disabled: true,
          accessLevel: COMMENTER
        }
      }

      // default edit link
      if (!props.editLink) {
        props.editLink = {
          item: pick(item, ['id', 'type', 'name']),
          disabled: true,
          accessLevel: EDITOR
        }
      }
    } else if (item.viewLinkKey) {
      // access less than editor and view link enabled - show it
      props.viewLink = {
        id: item.viewLinkKey,
        item: pick(item, ['id', 'type', 'name']),
        accessLevel: VIEWER
      }
    }

    // default view link
    if (!props.viewLink) {
      props.viewLink = {
        id: item.type === 'folder' ? null : 'open',
        item: pick(item, ['id', 'type', 'name']),
        disabled: true,
        accessLevel: VIEWER
      }
    }

    if (item.type === 'folder') {
      props.childCounts = { board: 0, folder: 0 }
      Object.values(item.children || {}).forEach(
        ({ type }) => props.childCounts[type]++
      )
    }

    return props
  }),
  withTranslation(),
  branch(
    ({ loaded }) => !loaded,
    renderComponent(mapProps(() => ({}))(Loader))
  ),
  asModal({})
)

export default ShareModalContainer
